import React, { useState } from 'react'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Header from '../Header';
import Footer from '../Footer';
import { useForm } from 'react-hook-form';
import authService from '../../appwrite/confi'
import { useNavigate } from 'react-router-dom';
import { Client, Databases, ID } from "appwrite"



const Contact = () => {

  const navigate = useNavigate()
  const [email, setemail] = useState('')
  const [Names, setNames] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState('')

  const create = (e) => {
    const client = new Client()
      .setEndpoint('https://cloud.appwrite.io/v1')
      .setProject('66da9a14000f970c8d3d');

    const databases = new Databases(client);
    e.preventDefault()
    const userDta = databases.createDocument(
      '66da9ac4001752138a64',
      '66da9af2002707555e9c',
      ID.unique(),
      { Names, email, subject, phone, message }
    );
    setNames('')
    setMessage('')
    setPhone('')
    setSubject('')
    setemail('')
  }



  return (
    <div>
      <Header />

      <div className=" md:flex justify-between p-10 sm:flex-row ">
        <div className=" m-auto">
          <h1 className='text-lg font-semibold ml-2'>Contact Us</h1>
          <h1 className='text-6xl font-semibold'>Have A Question?</h1>
          <h1 className='text-4xl font-semibold'>Get in Touch!</h1>
        </div>
        <div className="sm:mt-10">
          <form onSubmit={create}>
            <div className="flex gap-5">
              <div className="flex gap-2 mb-5 mt-5">
                <PersonOutlineOutlinedIcon />
                <input type="text" id="full-name" value={Names} onChange={(e) => { setNames(e.target.value) }}
                  name="full-name" maxlength="50" required className='border-b-2 rounded-sm outline-none text-lg  hover:border-black  transition-all duration-300' placeholder='Name' />
              </div>
              <div className="flex gap-2 mb-5 mt-5">
                <EmailOutlinedIcon />
                <input type="email" id="full-name" value={email} onChange={(e) => { setemail(e.target.value) }}
                  name="full-name" maxlength="50" required className='border-b-2 rounded-sm outline-none text-lg
                    hover:border-black  transition-all duration-300'placeholder='Email' />
              </div>
            </div>
            <div className="flex gap-5">
              <div className="flex gap-2 mb-5 mt-5">
                <LocalPhoneOutlinedIcon />
                <input type="text" id="full-name" name="full-name" value={phone} required onChange={(e) => { setPhone(e.target.value) }}
                  className='border-b-2 rounded-sm outline-none text-lg hover:border-black
                     transition-all duration-300' placeholder='Phone' />
              </div>
              <div className="flex gap-2 mb-5 mt-5">
                <ErrorOutlineOutlinedIcon />
                <input type="text" id="full-name" name="full-name" value={subject} maxlength="50"
                  required className='border-b-2 rounded-sm outline-none 
                    hover:border-black text-lg transition-all duration-300'
                  onChange={(e) => { setSubject(e.target.value) }} placeholder='Subject'
                />
              </div>
            </div>
            <div className="flex gap-2 mb-5 mt-5">
              <MessageOutlinedIcon />
              <textarea rows={4} cols={50} style={{ resize: "none" }}
                onChange={(e) => setMessage(e.target.value)} value={message} className='h-24 border-b-2 outline-none hover:border-black 
                text-lg transition-all duration-300' placeholder='Message' ></textarea>
            </div>

            <div className="p-4 bg-red-200 w-60 rounded-sm  flex gap-2">
              <SendOutlinedIcon />
              <button type='submit'>Send it</button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Contact